import keysCollection from '../../utilities/keysCollection'

export const Keys = keysCollection('SUBCATEGORIES', {
    TABLE_DEPARTMENT: 'TABLE_DEPARTMENT'
})
